<template>
  <div class="help"
       v-show="visible">
    <div class="help-box abs-center">
      <div class="closeBtn"
           @click="close"></div>
      <label class="title">{{language==='en'?'Help':'帮助'}}</label>
      <div class="help-left">
        <div class="label">{{infos.help_interface}}</div>
        <div class="info">{{infos.help_moveMouse}}</div>
        <div class="help-left-bg"></div>
        <div class="point one" v-tooltip="infos.help_clientLogoWeb"></div>
        <div class="point two" v-tooltip="infos.help_oldMagazine"></div>
        <div class="point three" v-tooltip="infos.help_prev"></div>
        <div class="point four" v-tooltip="infos.help_next"></div>
        <div class="point five" v-tooltip="infos.help_flipPage"></div>
        <div class="point six" v-tooltip="infos.help_dragPage"></div>
      </div>
      <div class="help-right">
        <div class="label">{{infos.help_operate}}</div>
        <div class="info">{{infos.help_keyInstruction}}</div>
        <div class="help-right-bg"></div>
        <div class="help-right-label cover">{{infos.help_cover}}</div>
        <div class="help-right-label prev">{{infos.help_prev}}</div>
        <div class="help-right-label next">{{infos.help_next}}</div>
        <div class="help-right-label back">{{infos.help_back}}</div>
        <div class="help-right-space">space</div>
        <div class="help-right-label space">{{infos.help_spaceZoom}}</div>
        <div class="help-right-mouse"></div>
        <div class="help-right-label mouse">{{infos.help_mouseFlipPage}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'helpview',
  props: {
    help_visible: Boolean,
    language: String,
  },
  data() {
    return {
      mode: false,
      infos: {
        help_interface: '界面',
        help_moveMouse: '鼠标触摸圆点查看说明',
        help_clientLogoWeb: '点击可跳转访问网站',
        help_oldMagazine: '点击可以跳转至往期期刊',
        help_jumpCover: '跳转封面',
        help_jumpPrev: '向前翻页',
        help_jumpNext: '向后翻页',
        help_jumpBack: '跳转封底',
        help_flipPage: '您可以在此处点击翻页',
        help_dragPage: '您可以在此处拖曳',
        help_operate: '操作',
        help_keyInstruction: '键盘，鼠标的操作说明',
        help_cover: '封面',
        help_back: '封底',
        help_prev: '向前翻',
        help_next: '向后翻',
        help_spaceZoom: '键盘空格键可缩放页面',
        help_mouseFlipPage: '鼠标滚轮键可以进行翻页',
      },
    };
  },
  computed: {
    visible() {
      return this.help_visible;
    },
  },
  methods: {
    close() {
      this.$store.commit('updateView', {
        view: 'book',
      });
    },
    help() {
      console.log(this.mode);
    },
  },
};
</script>
<style lang="less" scoped>
.info{
    color: white;
}
.help {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  z-index: 1000;
  &-box {
    width: 800px;
    height: 480px;
    background: #0b111c;
    border: 10px solid white;
    box-sizing: border-box;
    .title {
      font-size: 24px;
      left: 0px;
      position: absolute;
      color: white;
      margin: 10px 15px;
    }
    .point {
      background-image: url("~@/assets/icon/help_circle.png");
      height: 23px;
      width: 23px;
      top: 0px;
      position: absolute;
      cursor: pointer;
    }
    .one {
      margin: 115px 35px;
    }
    .two {
      margin: 205px 35px;
    }
    .three {
      margin: 295px 50px;
    }
    .four {
      margin: 295px 85px;
    }
    .five {
      margin: 205px 275px;
    }
    .six {
      margin: 255px 275px;
    }
    .help-left {
      position: absolute;
      width: 350px;
      height: 400px;
      margin: 55px 15px;
      left: 0px;
      color: white;
      text-align: left;
      &-bg {
        background-image: url("~@/assets/icon/helpBg.png");
        width: 254px;
        height: 176px;
        margin: 80px 50px;
      }
    }
    .help-right {
      position: absolute;
      width: 350px;
      height: 400px;
      margin: 55px 405px;
      padding-left: 15px;
      left: 0px;
      border-left: 1px solid white;
      color: white;
      text-align: left;
      &-bg{
          background-image: url("~@/assets/icon/help_arrow.png");
          width: 101px;
          height: 47px;
          margin: 70px 120px;
      }
      &-label{
         color: white;
         top: 0px;
         left: 0px;
         position: absolute;
      }
      .cover{
          margin: 95px 170px;
          width: 100px;
      }
      .back{
          margin: 170px 170px;
          width: 100px;
      }
      .prev{
          margin: 145px 245px;
          width: 100px;
      }
      .next{
          margin: 145px 85px;
          width: 100px;
      }
      &-space{
         background: #52575E;
         font-size: 10px;
         margin: 225px 125px;
         text-align: center;
         width: 120px;
         border-radius: 3px;
         line-height: 25px;
         top: 0px;
         left: 0px;
         position:absolute;
      }
      .space{
          margin: 260px 115px;
          width: 150px;
      }
      &-mouse{
         background-image: url("~@/assets/icon/help_mouse.png");
         margin: 305px 175px;
         text-align: center;
         width: 21px;
         height: 32px;
         top: 0px;
         left: 0px;
         position:absolute;
      }
      .mouse{
         margin: 345px 105px;
         width: 200px;
      }
    }
    .label {
      font-size: 18px;
      height: 30px;
      line-height: 30px;
    }
    .help-btn {
      position: absolute;
      margin: 55px 315px;
      width: 35px;
      height: 35px;
    }
    .closeBtn {
      width: 31px;
      height: 31px;
      position: absolute;
      right: 0px;
      margin-left: 390px;
      margin-top: 0px;
      background-image: url("~@/assets/icon/imgClose.jpg");
      cursor: pointer;
    }
    .check {
      position: absolute;
      margin: 100px 20px;
      left: 0;
    }
    .check-title {
      position: absolute;
      width: 100px;
      left: 0;
      margin: 95px 30px;
    }
  }
}
</style>
